(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["html-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window._videoModalInit) return;
  window._videoModalInit = true;

  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var iframe = modal.querySelector('iframe[data-video-src]');
    if (iframe && !iframe.src) {
      iframe.src = iframe.getAttribute('data-video-src');
    }

    var video = modal.querySelector('video');
    if (video) video.play();
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');

    if (!document.querySelector('.video-modal.is-open, .html-modal.is-open')) {
      document.body.style.overflow = '';
    }

    var iframe = modal.querySelector('iframe');
    if (iframe) iframe.src = '';

    var video = modal.querySelector('video');
    if (video) { video.pause(); video.currentTime = 0; }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-modal-open], [data-video-modal-open]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-modal-open') || trigger.getAttribute('data-video-modal-open');
      var modal = document.getElementById(id);
      if (modal) openModal(modal);
      return;
    }

    var closeEl = e.target.closest('[data-modal-close], [data-video-modal-close]');
    if (closeEl) {
      var modal = closeEl.closest('[data-modal], [data-video-modal]');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var open = document.querySelector('.video-modal.is-open, .html-modal.is-open');
    if (open) closeModal(open);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window._videoModalInit) return;
  window._videoModalInit = true;

  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var iframe = modal.querySelector('iframe[data-video-src]');
    if (iframe && !iframe.src) {
      iframe.src = iframe.getAttribute('data-video-src');
    }

    var video = modal.querySelector('video');
    if (video) video.play();
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');

    if (!document.querySelector('.video-modal.is-open')) {
      document.body.style.overflow = '';
    }

    var iframe = modal.querySelector('iframe');
    if (iframe) iframe.src = '';

    var video = modal.querySelector('video');
    if (video) { video.pause(); video.currentTime = 0; }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-modal-open], [data-video-modal-open]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-modal-open') || trigger.getAttribute('data-video-modal-open');
      var modal = document.getElementById(id);
      if (modal) openModal(modal);
      return;
    }

    var closeEl = e.target.closest('[data-modal-close], [data-video-modal-close]');
    if (closeEl) {
      var modal = closeEl.closest('[data-modal], [data-video-modal]');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var open = document.querySelector('.video-modal.is-open, .html-modal.is-open');
    if (open) closeModal(open);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
